import { PaymentMethodTypes } from "./payment-method";

export class PaymentMethodInfo {
  PaymentMethodType: PaymentMethodTypes;
  PaymentType: string;
  Frequency: string;
  PaymentInstrumentType: string;
}
